export function beforeSave(record) {
  const newRecord = {
    ...record,
    prefix: record.paymentNumber.prefix,
    nextNumber: record.paymentNumber.nextNumber,
    templateId: record.template?.id || null,
  };

  delete newRecord.paymentNumber;

  return newRecord;
}
